export enum RemoveGroupMembershipExecutionState {
  Warning = 1,
  TransferAssignments = 2,
  InProgress = 3,
}